import { useNavigate } from "react-router-dom";
import ProjectCard from "./ProjectCard";
import CTAButton from "./CTAButton";
import { useProjects } from "../../data/projects";
import { useHome, useFeaturedSlugs } from "../../data/content";
import Emphasis from "../../components/Emphasis";

function FeaturedWork() {
  const navigate = useNavigate();
  const projects = useProjects();
  const home = useHome();
  const featuredSlugs = useFeaturedSlugs();

  // Order comes from the drag-sorted list on the home page. Resolving through
  // `projects` means a project hidden by the privacy switch simply drops out.
  const featured = featuredSlugs
    .map((slug) => projects.find((p) => p.slug === slug))
    .filter(Boolean);
  return (
    <section id="featured-work" className="bg-background-light dark:bg-background-dark px-6 py-24">
      <div className="max-w-5xl mx-auto">

        {/* Header row */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-px bg-text-muted-light dark:bg-text-muted-dark" />
              <span className="font-sans text-xs tracking-[0.3em] text-text-muted-light dark:text-text-muted-dark uppercase">
                {home.featuredEyebrow}
              </span>
            </div>

            <h2 className="font-sans font-bold text-4xl md:text-5xl text-text-primary-light dark:text-text-primary-dark leading-tight mb-3">
              <Emphasis>{home.featuredHeading}</Emphasis>
            </h2>

            <p className="font-sans text-sm text-text-muted-light dark:text-text-muted-dark max-w-xs leading-relaxed">
              {home.featuredBlurb}
            </p>
          </div>

          <CTAButton label={home.featuredCtaLabel} variant="muted" arrow onClick={() => navigate("/work")} />
        </div>

        {/* 2×2 grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-4">
          {featured.map((project) => (
            <ProjectCard key={project.slug} {...project} />
          ))}
        </div>

      </div>
    </section>
  );
}

export default FeaturedWork;
